module.exports = __webpack_public_path__ + "static/mifid-3cf8d7017905396c4413bd1291b2f15a.jpg";